module.exports = __webpack_public_path__ + "img/bonus.9818acde.png";